import './index.css'
import React from 'react'
import { daySpanOptions } from 'constants/index'
import classNames from 'classnames'
import { IconButton } from '@mui/material'
const DaySpan = ({ daySpanSelected, onClick, ...rest }) => {
  return (
    <div className="inline-flex" {...rest}>
      <h2 className="text-normal text-bold color-primary k-mr-1">Past:</h2>
      {daySpanOptions.map((option, index) => (
        <IconButton
          sx={{ borderRadius: 0 }}
          aria-current="true"
          style={{width: '20px !important'}}
          size="samll"
          fullWidth='false'
          key={option}
          className={classNames('text-normal color-primary k-cursor-pointer dayspan-item', {
            'dayspan-border-left': index !== 0,
          })}
          onClick={() => onClick(option)}
        >
          <li
            style={{listStyleType: 'none', color:daySpanSelected === option ? '#0A78CD' : '#25245f',
            fontWeight:daySpanSelected === option ? 'bold' : '500'}}
          >
            {option}
          </li>
        </IconButton>
      ))}
    </div>
  )
}

export default DaySpan
